import { render, staticRenderFns } from "./ListAutoApproved.vue?vue&type=template&id=57e372c9"
import script from "./ListAutoApproved.vue?vue&type=script&lang=js"
export * from "./ListAutoApproved.vue?vue&type=script&lang=js"
import style0 from "./ListAutoApproved.vue?vue&type=style&index=0&id=57e372c9&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports